import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap";

class AdrEquipOperatorSnippetV3 extends Component {
  state = {
    snippetDropdownOpen: false,
  };

  toggleSnippetDropdown = () => {
    this.setState({ snippetDropdownOpen: !this.state.snippetDropdownOpen });
  };

  getOperatorCount = () => {
    const { snippetData } = this.props;
    const opIds = new Set(snippetData.map((o) => o.operatorId));
    return opIds.size;

    // MULTIPLE OPERATORS: FOR FUTURE USE
    // const opIdSet = new Set();
    // snippetData
    //   .map((sd) => sd.operators.map((o) => o.operatorId))
    //   .flat()
    //   .forEach((opId) => opIdSet.add(opId));
    // return opIdSet.size;
  };

  getOperatorIconClass = () => {
    return this.getOperatorCount() === 0
      ? "fa-lg mb-0 ml-1 badge-operator-icon-zero"
      : "fa-lg mb-0 ml-1";
  };

  getOperatorBadgeClass = () => {
    return this.getOperatorCount() === 0
      ? "badge badge-info badge-operator-zero"
      : "badge badge-danger badge-operator-count";
  };

  render() {
    const { snippetData } = this.props;
    const operatorCount = this.getOperatorCount();
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.snippetDropdownOpen}
          toggle={this.toggleSnippetDropdown}
        >
          <DropdownToggle
            className="px-1"
            color="secondary"
            outline
            disabled={operatorCount === 0}
          >
            <div>
              <FontAwesomeIcon icon="user" className={this.getOperatorIconClass()} />
              <span className={this.getOperatorBadgeClass()}>{operatorCount}</span>
            </div>
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem header>Operator(s) for This Equipment:</DropdownItem>
            {snippetData.map((d, index) => (
              <DropdownItem key={`operatorSnippetKey_${index}`} disabled>
                {d.wpShortCaption + ": " + d.fullName}
              </DropdownItem>
            ))}
            {/*
            MULTIPLE OPERATORS: FOR FUTURE USE
            {snippetData.map((sd, index) => (
              <DropdownItem key={`operatorSnippetKey_${index}`} disabled>
                {sd.wpShortCaption +
                  ": " +
                  sd.operators.map((o) => o.operatorFullName).join(", ")}
              </DropdownItem>
            ))} */}
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

export default AdrEquipOperatorSnippetV3;
